module.exports = __webpack_public_path__ + "static/media/Stormy_Frightened.f0f755ed.gif";